import React from 'react'
import PropTypes from 'prop-types'

import {
  DialogConfirmCellphone,
  DialogConfirmEmail,
  DialogEditCellphone,
  DialogEditEmail,
  DialogPassword,
} from './index'

import { dialogs } from '../../utils/constants'

const Dialogs = ({
  dialog,
  email,
  mobile,
  setDialog,
  setEmail,
  setMobile,
  setUpdatedEmail,
  setUpdatedMobile,
  username,
  userId,
  ...rest
}) => {
  const handleClose = () => setDialog(null)

  switch (dialog) {
    case dialogs.edit_email:
      return (
        <DialogEditEmail
          openConfirm={() => setDialog(dialogs.confirm_email)}
          onClose={handleClose}
          setEmail={setEmail}
          {...rest}
        />
      )

    case dialogs.confirm_email:
      return (
        <DialogConfirmEmail
          backToEdit={() => setDialog(dialogs.edit_email)}
          onClose={handleClose}
          email={email}
          setUpdatedEmail={setUpdatedEmail}
        />
      )

    case dialogs.edit_cellphone:
      return (
        <DialogEditCellphone
          openConfirm={() => setDialog(dialogs.confirm_cellphone)}
          onClose={handleClose}
          setMobile={setMobile}
          {...rest}
        />
      )

    case dialogs.confirm_cellphone:
      return (
        <DialogConfirmCellphone
          backToEdit={() => setDialog(dialogs.edit_cellphone)}
          onClose={handleClose}
          mobile={mobile}
          setUpdatedMobile={setUpdatedMobile}
          {...rest}
        />
      )

    case dialogs.edit_password:
      return <DialogPassword username={username} onClose={handleClose} userId={userId} />

    default:
      return <></>
  }
}

Dialogs.propTypes = {
  dialog: PropTypes.string,
  email: PropTypes.string,
  mobile: PropTypes.string,
  setDialog: PropTypes.func.isRequired,
  username: PropTypes.string.isRequired,
  setEmail: PropTypes.func.isRequired,
  setMobile: PropTypes.func.isRequired,
  setUpdatedEmail: PropTypes.func.isRequired,
  setUpdatedMobile: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
}

export default Dialogs
